import React, { useContext } from "react";
import { ContextList } from "../listContext";
import "./styles.css";

// Ячейка шапки таблицы. name — ключ сортировки (orderBy), isSort={false} отключает. По name же —
// класс колонки table__header-item_col_<name> (у ячеек тела — table__body-item_col_<name>, его
// ставит Table): страница может задать ширину / перенос отдельной колонке.
export default function ListHeaderItem({ name, isSort = true, children }) {
    const contextList = useContext(ContextList);
    const isSorted = isSort && contextList.sortKey === name;
    const columnClass = `table__header-item_col_${name}`;

    if (!isSort) {
        return <th className={`table__header-item ${columnClass}`}>{children}</th>;
    }

    return <th
        className={`table__header-item ${columnClass} table__header-item_sortable${isSorted ? ' table__header-item_sorted' : ''}`}
        onClick={() => contextList.setSort(name)}
        title="Сортировать"
    >
        {children}
        <span className="table__header-item-arrow">
            {isSorted ? (contextList.sortIsAsc ? '▲' : '▼') : ''}
        </span>
    </th>;
}
